import React, { useEffect } from 'react'
import './index.scss'

const RatingStar = ({ rank }) => {
  const maxStar = 5
  let fullStar
  let halfStar
  let emptyStar

  if (rank > maxStar) {
    fullStar = maxStar
  } else {
    fullStar = Math.floor(rank / 1)
    halfStar = Math.ceil(rank % 1)
    emptyStar = Math.abs(maxStar - (halfStar + fullStar))
  }

  return (
    <div className="RatingStar">
      <div className="rating-box" id="ratingBox">
        {fullStar && fullStar > 0 ? Array.from(Array(fullStar), (_, i) => <span className="rating-star full-star" key={i}></span>) : ''}
        {halfStar && halfStar > 0 ? Array.from(Array(halfStar), (_, i) => <span className="rating-star half-star" key={i}></span>) : ''}
        {emptyStar && emptyStar > 0 ? Array.from(Array(emptyStar), (_, i) => <span className="rating-star empty-star" key={i}></span>) : ''}
      </div>
    </div>
  )
}

export { RatingStar }
